import { useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { inputCls } from "./LoginCard";

export const FileOrLink = ({ value, onChange, accept, placeholder, testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
      toast.success(`${file.name} uploaded`);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <div className="flex gap-2">
      <input data-testid={`${testid}-url`} className={inputCls} placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} />
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={pick} data-testid={`${testid}-file`} />
      <button type="button" data-testid={`${testid}-upload-btn`} onClick={() => ref.current?.click()} disabled={busy}
        className="flex shrink-0 items-center gap-2 rounded-xl border border-[var(--line)] px-4 font-mono text-xs uppercase tracking-[0.15em] hover:border-[var(--cash)] disabled:opacity-60">
        {busy ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />} Upload
      </button>
    </div>
  );
};
